/**
 * ReportsHarvestInspectionsPersonPickerFaultPercentage
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectReportsHarvestInspectionsPersonValue } from '../../services/reportsHarvestInspectionsPeople/selectors';

interface Props {
    pickerFaultPercentage?: ?number;
}

export class ReportsHarvestInspectionsPersonPickerFaultPercentage extends React.PureComponent<Props> {
    render() {
        const { pickerFaultPercentage } = this.props;
        if (!pickerFaultPercentage && pickerFaultPercentage !== 0) return null;
        return `${pickerFaultPercentage}%`;
    }
}

const mapStateToProps = createStructuredSelector({
    pickerFaultPercentage: makeSelectReportsHarvestInspectionsPersonValue(
        'pickerFaultPercentage'
    )
});

export default connect(mapStateToProps)(
    ReportsHarvestInspectionsPersonPickerFaultPercentage
);
